import NextImage, { NextImageProps } from '@/decodo/components/atoms/Image';
import LinkButton from '@/decodo/components/atoms/LinkButton';

export function Logo({ image, url }: { image: NextImageProps; url: string }) {
  return (
    <LinkButton
      noStyles
      classNames={{
        root: 'focus-visible:outline-current shrink-0 outline-offset-4 h-5 grow-0 max-h-[20px]',
      }}
      href={url || '#'}
      aria-label='Go to Decodo Homepage'
    >
      <NextImage
        {...image}
        aria-hidden={true}
        classNames={{
          container: 'h-full',
          image: 'h-full w-auto',
        }}
      />
    </LinkButton>
  );
}
